import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Translate from "../../../Components/Multilanguage/Translate";
import * as service from "./service";

const VerifyParentalPinReset = () => {
  const [isVerifying, setIsVerifying] = useState(true);
  const [linkError, setLinkError] = useState("");

  const { token } = useParams();
  const navigate = useNavigate();

  const accessToken = useSelector((state) => state.accessToken?.value);
  const projectInfo = useSelector((state) => state?.projectInfo?.value);

  const appInfo = {
    accessToken,
    projectDetails: projectInfo,
  };

  useEffect(() => {
    const verifyResetLink = async () => {
      try {
        const expiryTime = Math.floor(Date.now() / 1000) + 24 * 60 * 60;
        const response = await service.verifyParentalPinReset(
          appInfo,
          token,
          expiryTime
        );

        if ((response?.status === 200 || response?.success === true) && response?.data?.data?.id) {
          const requestId = response?.data?.data?.id;
          sessionStorage.setItem("parentalPinResetRequestId", requestId);
          navigate("/reset-parental-pin/confirm", {
            replace: true,
            state: { requestId },
          });
          return;
        }

        setLinkError(response?.data?.message || response?.message || "Link expired, please send a new one");
      } catch (err) {
        setLinkError(err?.response?.data?.message || "Link expired, please send a new one");
      } finally {
        setIsVerifying(false);
      }
    };

    if (token) {
      verifyResetLink();
    } else {
      setLinkError("Invalid reset link");
      setIsVerifying(false);
    }
  }, [token]);

  return (
    <div className="resetPassword" role="main" aria-label="Verify Parental PIN Reset Link Page">
      <ToastContainer />
      <div className="wrapper">
        <h1 className="heading"><Translate textKey={"reset_parental_pin"} /></h1>
        <div className="contents">
          <div className="formSection">
            {isVerifying && <span className="success"><Translate textKey={"verifying_reset_link"} /></span>}

            {!isVerifying && linkError && (
              <>
                <span className="error">{linkError}</span>
                <div
                  className="buttonContainer"
                  onClick={() => navigate("/parental-settings")}
                  tabIndex={0}
                  role="button"
                  aria-label="Request New Reset Link"
                  onKeyDown={(e) => {
                    if (e.key === "Enter" || e.key === " ") {
                      navigate("/parental-settings");
                    }
                  }}
                >
                  <div className="background"></div>
                  <button type="button" aria-label="Request New Reset Link">
                    <Translate textKey={"request_new_link"} />
                  </button>
                </div>
              </>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default VerifyParentalPinReset;
